import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SubscriptionState } from '~app/farp-odq/store/subscription';
import { SeeParticularConditions, SeeSubscriptionReceipt } from '~app/farp-odq/store/subscription/subscription.actions';
import { PaymentReceipt, SelectedPremiumInfo, SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';


@Component({
    selector: 'odq-confirmation-payment',
    templateUrl: './confirmation-payment.component.html',
    styleUrls: ['./confirmation-payment.component.scss', '../styles/subscription-forms.css'],
    standalone: false
})
export class ConfirmationPaymentComponent {
  @Input() paymentReceipt: PaymentReceipt;
  @Input() selectedPremium: SelectedPremiumInfo;
  @Input() model: SubscriptionFormViewModel;
  
  loadingReport$ = this.store.select<boolean>(SubscriptionState.loadingReport);

  constructor(private store: Store, private router: Router) {

  }

  onDownloadConditions() {
     this.store.dispatch(new SeeParticularConditions(this.selectedPremium.memberId,
          this.selectedPremium.year, this.selectedPremium.permitNumber));
  }

  onDownloadReceipt() {
    this.store.dispatch(new SeeSubscriptionReceipt(this.selectedPremium.memberId,
      this.paymentReceipt.orderId, this.paymentReceipt.orderId, this.selectedPremium.permitNumber));
  }

  goToHomePage() {
    this.router.navigateByUrl('/home');
  }
  
}